module.exports = " <ul class=bpl__tabs v-if=hasArchives> <li class=bpl__tabs__item :class=\"{'bpl__tabs__item--active': !isArchive}\" @click=changeArchiveMode(false)>Index</li> <li class=bpl__tabs__item :class=\"{'bpl__tabs__item--active': isArchive}\" @click=changeArchiveMode(true)>Archive</li> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/shared/bpl/BluePrintingLevelTabs.vue
// module id = 178
// module chunks = 0